(() => {
  if (window.hpKlarnaSyncInstalled) return;
  window.hpKlarnaSyncInstalled = true;
  let queued = false;
  const sync = () => {
    queued = false;
    const cart = document.querySelector('[data-hp-klarna-cart-total]');
    const product = document.querySelector('product-info[id^="MainProduct-"]');
    const summary = product?.querySelector('hp-iphone-purchase-summary');
    const source = product?.querySelector('[data-hp-klarna-product-amount]');
    let amount = null;
    let available = false;
    if (cart) {
      amount = Number(cart.dataset.hpKlarnaCartTotal);
      available = Number(cart.dataset.hpKlarnaCartCount) > 0;
    } else if (summary) {
      const raw = summary.dataset.hpKlarnaTotal;
      amount = raw && Number(raw);
      available = summary.dataset.hpKlarnaAvailable === 'true';
    } else if (source) {
      const quantity = Number(product.querySelector('input[name="quantity"]')?.value || 1);
      amount = Number(source.dataset.hpKlarnaProductAmount) * quantity;
      available = source.dataset.hpKlarnaAvailable === 'true' && Number.isSafeInteger(quantity) && quantity > 0;
    }
    available = available && Number.isSafeInteger(amount) && amount > 0;
    let changed = false;
    document.querySelectorAll('klarna-placement').forEach(placement => {
      if (!['credit-promotion-badge', 'credit-promotion-auto-size'].includes(placement.getAttribute('data-key'))) return;
      if (!cart && !product) return;
      placement.hidden = !available;
      if (available && placement.getAttribute('data-purchase-amount') !== String(amount)) {
        placement.setAttribute('data-purchase-amount', String(amount));
        changed = true;
      }
    });
    if (changed) window.Klarna?.OnsiteMessaging?.refresh?.();
  };
  const schedule = () => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(sync);
    }
  };
  const start = () => {
    new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-purchase-amount', 'data-hp-klarna-total', 'data-hp-klarna-available', 'data-hp-klarna-product-amount', 'data-hp-klarna-cart-total', 'data-hp-klarna-cart-count']
    });
    document.addEventListener('change', schedule);
    document.addEventListener('input', schedule);
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
